/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryticketslater2Inputs */

const en_entryticketslater2 = /** @type {(inputs: Entryticketslater2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales and more settings are on the event page after saving.`)
};

const de_entryticketslater2 = /** @type {(inputs: Entryticketslater2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufe und weitere Einstellungen findest du nach dem Speichern auf der Eventseite.`)
};

/**
* | output |
* | --- |
* | "Sales and more settings are on the event page after saving." |
*
* @param {Entryticketslater2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryticketslater2 = /** @type {((inputs?: Entryticketslater2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryticketslater2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryticketslater2(inputs)
	return de_entryticketslater2(inputs)
});
export { entryticketslater2 as "entryTicketsLater" }